// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonPin_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 6C7.10457 6 8 5.10457 8 4C8 2.89543 7.10457 2 6 2C4.89543 2 4 2.89543 4 4C4 5.10457 4.89543 6 6 6Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.25C10 6.30724 8.19251 9.17535 6.63698 11.1992C6.41773 11.4844 6.20348 11.7529 6 12C5.79652 11.7529 5.58227 11.4844 5.36302 11.1992C3.80749 9.17535 2 6.30724 2 4.25C2 1.90279 3.79086 0 6 0C8.20914 0 10 1.90279 10 4.25ZM9 4.25C9 5.14853 8.52735 6.39335 7.74873 7.76024C7.22377 8.68182 6.59991 9.59062 6 10.3851C5.40009 9.59062 4.77623 8.68182 4.25127 7.76024C3.47265 6.39335 3 5.14853 3 4.25C3 2.3971 4.39939 1 6 1C7.60061 1 9 2.3971 9 4.25Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 7C9.10457 7 10 6.10457 10 5C10 3.89543 9.10457 3 8 3C6.89543 3 6 3.89543 6 5C6 6.10457 6.89543 7 8 7Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 5.66667C13 8.20668 11.0626 11.6738 9.232 14.3156C8.80706 14.9288 8.38787 15.4976 8 16C7.61213 15.4976 7.19294 14.9288 6.768 14.3156C4.93737 11.6738 3 8.20668 3 5.66667C3 2.53705 5.23858 0 8 0C10.7614 0 13 2.53705 13 5.66667ZM11 5.66667C11 6.71461 10.4691 8.26481 9.50786 10.0648C9.04984 10.9225 8.52886 11.7738 8 12.5696C7.47114 11.7738 6.95016 10.9225 6.49214 10.0648C5.53089 8.26481 5 6.71461 5 5.66667C5 3.39904 6.57104 2 8 2C9.42896 2 11 3.39904 11 5.66667Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.5C20 12.6145 16.385 18.3507 13.274 22.3983C12.8355 22.9689 12.407 23.5058 12 24C11.593 23.5058 11.1645 22.9689 10.726 22.3983C7.61498 18.3507 4 12.6145 4 8.5C4 3.80558 7.58172 0 12 0C16.4183 0 20 3.80558 20 8.5ZM18 8.5C18 10.2971 17.0547 12.7867 15.4975 15.5205C14.4475 17.3636 13.1998 19.1812 12 20.7703C10.8002 19.1812 9.55245 17.3636 8.50254 15.5205C6.94529 12.7867 6 10.2971 6 8.5C6 4.79419 8.79879 2 12 2C15.2012 2 18 4.79419 18 8.5Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 16C19.3137 16 22 13.3137 22 10C22 6.68629 19.3137 4 16 4C12.6863 4 10 6.68629 10 10C10 13.3137 12.6863 16 16 16Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26 11.3333C26 16.9824 21.2086 24.9243 17.2474 30.3397C16.8196 30.9246 16.4014 31.4801 16 32C15.5986 31.4801 15.1804 30.9246 14.7526 30.3397C10.7914 24.9243 6 16.9824 6 11.3333C6 5.07411 10.4772 0 16 0C21.5228 0 26 5.07411 26 11.3333ZM24 11.3333C24 13.9461 22.7338 17.4129 20.7799 21.0717C19.3444 23.7598 17.6209 26.4008 16 28.6533C14.3791 26.4008 12.6556 23.7598 11.2201 21.0717C9.26618 17.4129 8 13.9461 8 11.3333C8 5.93609 11.8096 2 16 2C20.1904 2 24 5.93609 24 11.3333Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonPin is a generated icon component.
 */
let IconCommonPin = IconCommonPin_1 = class IconCommonPin extends IconBaseElement {
    render() {
        return html `${IconCommonPin_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonPin.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonPin = IconCommonPin_1 = __decorate([
    customElement('zui-icon-common-pin')
], IconCommonPin);
export { IconCommonPin };
